
  import { useIntegrationDetailsStore } from '@/stores/integrationDetails';
  import { isOnFreePlan } from '@/ui/auth/auth';
  import MultiStepConfigurationModal from './multiStepModal/MultiStepConfigurationModal.vue';
  import SingleStepConfigurationModal from './SingleStepConfigurationModal.vue';
  import { defineComponent } from 'vue';

  export default defineComponent({
    components: {
      MultiStepConfigurationModal,
      SingleStepConfigurationModal,
    },
    setup() {
      const store = useIntegrationDetailsStore();
      const { isSingleStep } = store;

      const openModal = () => {
        if (isSingleStep) {
          store.openModal();
        }

        store.openMultiStepModal(true);
      };

      return {
        isOnFreePlan,
        isSingleStep,
        openModal,
      };
    },
  });
